import axios from "axios";
import { Base_Url } from "../API/config";

// Create an Axios instance
const apiClient = axios.create({
    baseURL: Base_Url, 
});

apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('ct_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
export default apiClient;
